"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useMultipointStringConvert_1 = __importDefault(require("./useMultipointStringConvert"));
const useInnerCoordinates_1 = __importDefault(require("../../../../../projection/useInnerCoordinates"));
const tech_1 = require("../../../../../../tech");
const Config_1 = require("../../../../../../tech/Config");
function useAddresses() {
    const url = (0, Config_1.getConfigValue)("COMMON_API_BASE_PATH") + "/index.php";
    const stringToPoint = (0, useMultipointStringConvert_1.default)();
    const convertLocation = (0, useInnerCoordinates_1.default)();
    const get = async (lau) => {
        const result = await (0, tech_1.fetchPostAction)("address", {
            pasport: (0, Config_1.getConfigValue)("PASPORT_ID"),
            lau: lau + ""
        }, url);
        const data = result.data || [];
        if (result.data === undefined)
            console.error("Fetching addresses failed");
        return data.map((d) => {
            const location = stringToPoint(d.st_astext);
            const convertedLocation = convertLocation(location);
            const searchString = d.cela_adresa.split(",")[0];
            return {
                ulice: d.ulice,
                cisloPopisne: d.cp,
                cisloOrientacni: Number(d.co),
                psc: d.psc,
                obec: d.obec,
                location: convertedLocation,
                searchString
            };
        });
    };
    return {
        fetchAddresses: get
    };
}
exports.default = useAddresses;
